// extracted by mini-css-extract-plugin
module.exports = {"list-item":"FeatureItem_list-item__KHxtL"};